import {SUPPORT_EMAIL} from '../lib/site';
import {FooterBrand} from './FooterBrand';

const footerLinks = [
  {href: '/', label: 'Home'},
  {href: '/#programs', label: 'Programs'},
  {href: '/#events', label: 'Events'},
  {href: '/#stories', label: 'Stories'},
  {href: '/#about', label: 'About'}
];

export const SiteFooter = () => (
  <footer className="border-t border-white/10 bg-[var(--nx-ink)] px-[clamp(20px,6vw,88px)] py-[30px] text-white/70">
    <div className="mx-auto grid max-w-[1180px] gap-[18px]">
      <div className="flex flex-wrap items-center justify-between gap-[18px]">
        <FooterBrand />
        <nav className="flex flex-wrap gap-4" aria-label="Footer">
          {footerLinks.map((link) => (
            <a className="text-sm font-normal text-white/70 transition-colors hover:text-white" href={link.href} key={link.href}>
              {link.label}
            </a>
          ))}
          <a className="text-sm font-normal text-white/70 transition-colors hover:text-white" href={`mailto:${SUPPORT_EMAIL}`}>
            Email
          </a>
        </nav>
      </div>
      <p className="m-0 border-t border-white/10 pt-[18px] text-[.84rem]">
        © {new Date().getFullYear()} United Foundation for Arts & Technology. Nonprofit arts, technology, education, and community programming.
      </p>
    </div>
  </footer>
);
